module.exports = __webpack_public_path__ + "assets/img/icon11-menu.6e4a2cdb.svg";